// extracted by mini-css-extract-plugin
export default {"flex-container":"styles_flex-container__aZ+Qn"};